import { InlineLoader } from '../PageLoader'

export const AsyncLoaderComponent = <InlineLoader />
